module.exports = __webpack_public_path__ + "static/progetto_panoramicalliving7-3c788eaa07aac27a312f5cf6ea547a04.jpg";